import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ChartGroupSpecialCausesReviewView } from "src/components/views/spc/processImprovement/ChartGroupSpecialCausesReviewView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/specialCauses/chartGroups")({
	staticData: {
		title: i18n.t("control_chart_group_special_causes"),
		legacyViewKey: "controlChartGroupSpecialCausesReviewView",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <ChartGroupSpecialCausesReviewView />;
}
